import { format } from 'date-fns';
import { Calendar } from 'lucide-react';

interface DateRangeDisplayProps {
    startDate: string;
    endDate: string;
}

const DateRangeDisplay = ({ startDate, endDate }: DateRangeDisplayProps) => {
    const formatDisplayDate = (dateStr: string) => {
        try {
            const date = new Date(dateStr);
            return format(date, 'MMM dd, yyyy');
        } catch {
            return dateStr;
        }
    };

    return (
        <div className="flex items-center gap-2 text-sm text-text-text-secondary daterange-top-nav">
            <Calendar className="w-4 h-4" />
            <span>
                {formatDisplayDate(startDate)} - {formatDisplayDate(endDate)}
            </span>
        </div>
    );
};

export default DateRangeDisplay;
